export default __webpack_public_path__ + "static/media/active.a386690e.svg";